/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Overlay_Water_ShortInputs */

const bn_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const de_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const el_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const en_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const es_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const fr_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EAU`)
};

const hi_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डब्ल्यूटीआर`)
};

const hu_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const id_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const it_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const ja_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const ko_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const nl_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const pl_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const pt_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const ru_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВТР`)
};

const sv_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const tr_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const uk_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const vi_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const zh_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

const zh_hant_cipher_overlay_water_short = /** @type {(inputs: Cipher_Overlay_Water_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WTR`)
};

/**
* | output |
* | --- |
* | "WTR" |
*
* @param {Cipher_Overlay_Water_ShortInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_overlay_water_short = /** @type {((inputs?: Cipher_Overlay_Water_ShortInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Overlay_Water_ShortInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_overlay_water_short(inputs)
	if (locale === "de") return de_cipher_overlay_water_short(inputs)
	if (locale === "el") return el_cipher_overlay_water_short(inputs)
	if (locale === "en") return en_cipher_overlay_water_short(inputs)
	if (locale === "es") return es_cipher_overlay_water_short(inputs)
	if (locale === "fr") return fr_cipher_overlay_water_short(inputs)
	if (locale === "hi") return hi_cipher_overlay_water_short(inputs)
	if (locale === "hu") return hu_cipher_overlay_water_short(inputs)
	if (locale === "id") return id_cipher_overlay_water_short(inputs)
	if (locale === "it") return it_cipher_overlay_water_short(inputs)
	if (locale === "ja") return ja_cipher_overlay_water_short(inputs)
	if (locale === "ko") return ko_cipher_overlay_water_short(inputs)
	if (locale === "nl") return nl_cipher_overlay_water_short(inputs)
	if (locale === "pl") return pl_cipher_overlay_water_short(inputs)
	if (locale === "pt") return pt_cipher_overlay_water_short(inputs)
	if (locale === "ru") return ru_cipher_overlay_water_short(inputs)
	if (locale === "sv") return sv_cipher_overlay_water_short(inputs)
	if (locale === "tr") return tr_cipher_overlay_water_short(inputs)
	if (locale === "uk") return uk_cipher_overlay_water_short(inputs)
	if (locale === "vi") return vi_cipher_overlay_water_short(inputs)
	if (locale === "zh") return zh_cipher_overlay_water_short(inputs)
	return zh_hant_cipher_overlay_water_short(inputs)
});